import { Component, Input } from '@angular/core';
import { IntegrationJazzhr } from '@app/models/company/settings/integrations/jazzhr.model';
import { AuthService } from '@app/services';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-settings-jazzhr-form',
    templateUrl: './jazzhr.template.html',
})
export class JazzhrForm extends BaseForm {
    isLoading = false;

    @Input()
    model: IntegrationJazzhr = new IntegrationJazzhr();

    constructor(private auth: AuthService) {
        super();
    }

    setId(id: number) {
        this.isLoading = true;
        IntegrationJazzhr.param('company', this.auth.company.id)
            .find(id)
            .then((model) => {
                this.model = model;
                this.isLoading = false;
            });
    }

    reset(): void {
        this.model = new IntegrationJazzhr();
    }
}
